// React
import * as React from 'react';
import ReactDOM from 'react-dom/client';

// Router
// App
import { App } from './App';

// Logger
import getLogger, { Logger } from './log';

// eslint-disable-line
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router';
// Debug


const logger: Logger = getLogger();

if (process.env.NODE_ENV === 'development') {
}
if (process.env.NODE_ENV === 'production') {
  const refSlug: string = process.env.REACT_APP_VCS_REF_SLUG;
  const refName: string = process.env.REACT_APP_VCS_REF_NAME;
  const revision: string = process.env.REACT_APP_VCS_COMMIT;
  const env: string = process.env.NODE_ENV;
  logger.info(`Version ${refSlug}/${refName} (${revision}) [${env}]`);
}

logger.debug('REACT_APP_PRODUCTION', process.env.REACT_APP_PRODUCTION);
if(process.env.REACT_APP_PRODUCTION === 'false') {
  logger.debug('REACT_APP_DEMO_LOGIN_ENABLED', process.env.REACT_APP_DEMO_LOGIN_ENABLED);
}

// Helper method to test locale setting in localStorage
(window as any).appSetLocale = (value: string = null): void => {
  window.localStorage.setItem('locale', value);
};

// Helper method to access the root logger
(window as any).appLogger = getLogger();

const router = createBrowserRouter(createRoutesFromElements(<Route path="*" element={<App/>}/>));

ReactDOM.createRoot(document.getElementById('root')).render(<RouterProvider router={router}/>);
